// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb7bd0f7","453":"50e836ee","732":"d76752b2"}[chunkId] + ".chunk.js";
};